import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
  headers: { "X-Requested-With": "XMLHttpRequest" },
});

export const COMPANY_KEY = "ww_company";
api.interceptors.request.use((cfg) => {
  const company = localStorage.getItem(COMPANY_KEY);
  if (company) cfg.headers["X-Company-Id"] = company;
  return cfg;
});

const NO_RETRY = ["/auth/login", "/auth/signup", "/auth/refresh", "/auth/accept-invite", "/auth/logout"];
let refreshing = null;

api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config;
    if (error.response?.status === 401 && cfg && !cfg._retry && !NO_RETRY.some((u) => cfg.url.startsWith(u))) {
      cfg._retry = true;
      refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
      try {
        await refreshing;
        return api(cfg);
      } catch {
        window.dispatchEvent(new Event("auth:expired"));
      }
    }
    return Promise.reject(error);
  }
);

export const get = (url, params) => api.get(url, { params }).then((r) => r.data);
export const post = (url, body) => api.post(url, body).then((r) => r.data);
export const put = (url, body) => api.put(url, body).then((r) => r.data);
export const patch = (url, body) => api.patch(url, body).then((r) => r.data);
export const del = (url) => api.delete(url).then((r) => r.data);

export function errorMessage(err) {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail.map((d) => `${d.loc?.slice(-1)[0] ? `${d.loc.slice(-1)[0]}: ` : ""}${d.msg?.replace(/^Value error, /, "")}`).join(" · ");
  }
  if (err?.response?.status >= 500) return "Server error. Please try again.";
  const msg = err?.message || String(err);
  if (/Network Error/i.test(msg)) return "Network error. Check your connection and try again.";
  return msg;
}
